<template>
    <el-dialog title="售后报单表" :visible="visibleAfterSales" width="80%" @close="closeDialog" :close-on-click-modal="false"
        height="600px" append-to-body>
        <el-form :model="info" ref="infoForm" label-width="120px" :rules="rules">
            <div slot="header" class="clearfix">
                <span>售后报单信息:</span>
            </div>
            <el-row>
                <el-col :span="12">
                    <!-- 客户信息 -->
                    <el-form-item label="客户姓名" prop="contactsName">
                        <el-input v-model="info.contactsName"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="客户手机号" prop="contactsMobile">
                        <el-input v-model="info.contactsMobile"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="客户地址" prop="customAddress">
                        <el-input v-model="info.customAddress"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 动态表格 -->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="售后产品" prop="goodsIds">
                        <el-table :data="productFaults" border style="width: 100%">
                            <el-table-column label="产品名称" width="200">
                                <template #default="{ row }">
                                    <el-select v-model="row.goodsId" placeholder="选择产品" :disabled="row.submitted"
                                        @change="handleGoodsChange(row)">
                                        <el-option v-for="goods in availableGoods" :key="goods.id" :label="goods.name"
                                            :value="goods.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <!-- 是否提货delivery：0是1否,必填 -->
                            <el-table-column label="是否提货" prop="delivery">
                                <template #default="{ row }">
                                    <el-radio-group v-model="row.delivery" :disabled="row.submitted">
                                        <el-radio label="0">是</el-radio>
                                        <el-radio label="1">否</el-radio>
                                    </el-radio-group>
                                </template>
                            </el-table-column>
                            <!-- 如果选择0是提货才必须选择前仓 -->
                            <el-table-column label="前仓" prop="warehouseId">
                                <template #default="{ row }">
                                    <el-select v-if="row.delivery == '0'" v-model="row.warehouseId" placeholder="请选择前仓"
                                        :disabled="row.submitted" clearable>
                                        <el-option v-for="item in WarehouseList" :key="item.id"
                                            :label="item.warehouseName" :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="工程师" prop="engineerId">
                                <template #default="{ row }">
                                    <el-select v-model="row.engineerId" placeholder="请选择工程师" filterable remote
                                        :disabled="row.submitted" :remote-method="handleRemote" clearable>
                                        <el-option v-for="item in users" :key="item.id" :label="item.realName"
                                            :value="item.id">
                                        </el-option>
                                    </el-select>
                                </template>
                            </el-table-column>
                            <el-table-column label="故障图片">
                                <template #default="{ row }">
                                    <ImageUpload action="#" :multiple="true" :inTable="true" :limit="5"
                                        :disabled="row.submitted" @uploaded="(urls) => handleUploaded(urls, row)"
                                        :uploaded-images="row.faultPhotos" />
                                </template>
                            </el-table-column>
                            <!-- 故障视频 -->
                            <el-table-column label="故障视频">
                                <template #default="{ row }">
                                    <videoAndFileUpload action="#" :multiple="false" :limit="1"
                                        :disabled="row.submitted" @uploaded="(urls) => handleUploadVideo(urls, row)"
                                        :uploaded-images="row.faultVideos" />
                                </template>
                            </el-table-column>
                            <el-table-column label="故障现象说明">
                                <template #default="{ row }">
                                    <el-input type="textarea" v-model="row.faultPhenomenon" :disabled="row.submitted">
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="240">
                                <template #default="{ row, $index }">
                                    <el-button type="text" size="small"
                                        :icon="row.submitted ? 'el-icon-check' : 'el-icon-upload'"
                                        :loading="!!row.submitting"
                                        :disabled="row.submitted || row.submitting"
                                        @click="submitRow($index)">
                                        {{ row.submitting ? '提交中' : (row.submitted ? '已提交' : '提交') }}
                                    </el-button>
                                    <el-button type="text" size="small" @click="removeRow($index)" icon="el-icon-delete"
                                        :disabled="row.submitted || row.submitting">
                                        删除
                                    </el-button>
                                    <el-button v-if="$index === 0" type="text" size="small" @click="addRow"
                                        :disabled="!canAddRow" icon="el-icon-plus">
                                        新增产品
                                    </el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div style="margin-top: 10px; text-align: right;" v-show="productFaults.length == 0">
                            <el-button type="primary" size="small" @click="addRow"
                                :disabled="!canAddRow">新增产品</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <span class="footer-tip" v-if="productFaults.length > 1">
                <i class="el-icon-info"></i>
                已提交 {{ submittedCount }} / {{ productFaults.length }} 个产品
            </span>
            <el-button type="danger" size="small" @click="closeDialog" icon="el-icon-close">取消</el-button>
            <el-button type="primary" size="small" @click="submit" icon="el-icon-upload">{{ submitButtonText }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { getMerchantOrder, addAfterSaleOrder, getGoodList } from "@/api/work/waterProject/merchants";
import { findUserList } from "@/api/work/projectService";
import { findPureWaterGoodsByRootDepartId } from "@/api/salesCloud/goodsQr";
import ImageUpload from "@/components/imageUpload/ImageUpload";
import videoAndFileUpload from "@/components/videoAndFileUpload/videoAndFileUpload";
export default {
    name: "ViewAfterSales",
    props: {
        visibleAfterSales: {
            type: Boolean,
            required: true,
        },
        afterSalesId: {
            type: [String, Number],
            required: true,
        },
        WarehouseList: {
            type: Array,
            required: true,
        },
    },
    components: {
        ImageUpload,
        videoAndFileUpload
    },
    data() {
        return {
            goodsList: [], // 售后产品
            productFaults: [this.getInitialProductFault()],
            info: this.getInitialInfo(),
            users: [],
            rules: {
                contactsName: [{ required: true, message: "请输入客户姓名", trigger: "blur" }],
                contactsMobile: [{ required: true, message: "请输入客户手机号", trigger: "blur" }],
                customAddress: [{ required: true, message: "请输入客户地址", trigger: "blur" }],
            }
        };
    },
    created() {
        if (this.afterSalesId) {
            this.loadData();
        }
    },
    computed: {
        availableGoods() {
            const selectedIds = this.productFaults
                .map(item => item.goodsId)
                .filter(Boolean);
            return this.goodsList.filter(goods => !selectedIds.includes(goods.id));
        },
        canAddRow() {
            return this.productFaults.length < this.goodsList.length;
        },
        submittedCount() {
            return this.productFaults.filter(item => item.submitted).length;
        },
        submitButtonText() {
            if (this.productFaults.length <= 1) return '提交';
            if (this.submittedCount === this.productFaults.length) return '全部完成';
            return '提交所有未处理';
        },
    },
    watch: {
        visibleAfterSales(newVal) {
            if (newVal && this.afterSalesId) {
                this.loadData();
            }
        },
    },
    methods: {
        getInitialProductFault() {
            return {
                goodsId: "",
                delivery: "",
                warehouseId: "",
                faultPhotos: [],
                faultPhenomenon: "",
                faultVideos: [],
                engineerId: "",
                submitting: false,
                submitted: false
            };
        },
        getInitialInfo() {
            return {
                declarationId: "",
                contactsName: "",
                contactsMobile: "",
                customAddress: "",
                goodsIds: [],
                delivery: "",
            };
        },
        validateRow(row) {
            if (!row.goodsId) {
                this.$message.error("请选择产品");
                return false;
            }
            return true;
        },
        submit() {
            this.$refs.infoForm.validate(async (valid) => {
                if (!valid) {
                    this.$message.error("请完善基本信息");
                    return;
                }

                // Validate all product rows
                const invalidRows = this.productFaults.filter(row => {
                    if (!row.goodsId) return true;
                    /* if (!row.delivery) return true;
                    if (row.delivery === '0' && !row.warehouseId) return true;
                    if (!row.engineerId) return true;
                    if (!row.faultPhenomenon) return true; */
                    return false;
                });

                if (invalidRows.length > 0) {
                    this.$message.error("请完善所有售后产品必填信息");
                    return;
                }

                if (this.productFaults.length == 0) {
                    this.$message.error("请添加售后产品");
                    return;
                }

                // 多产品场景下:逐行提交,提交成功的数据立即更新显示最新状态,
                // 提交过程中弹窗保持打开以便用户继续处理其他产品。
                if (this.productFaults.length > 1) {
                    const pendingIndexes = this.productFaults
                        .map((row, idx) => (row.submitted || row.submitting ? null : idx))
                        .filter(idx => idx !== null);
                    if (pendingIndexes.length === 0) {
                        this.$message.success("所有产品已提交,您可手动关闭弹窗");
                        return;
                    }
                    // 顺序提交未处理的产品行
                    for (const idx of pendingIndexes) {
                        try {
                            await this.doSubmitRow(idx);
                        } catch (e) {
                            // 单行提交失败不影响后续行的提交,这里给个提示后继续
                            this.$message.error(e.message || "提交失败");
                        }
                    }
                    return;
                }

                // 单产品场景:沿用原逻辑,一次性提交并关闭弹窗
                try {
                    const payload = {
                        declarationId: this.info.declarationId,
                        contactsName: this.info.contactsName,
                        contactsMobile: this.info.contactsMobile,
                        customAddress: this.info.customAddress,
                        goods: this.productFaults.map(row => ({
                            goodsId: row.goodsId,
                            delivery: row.delivery,
                            warehouseId: row.delivery === '0' ? row.warehouseId : '',
                            faultPhotos: row.faultPhotos.map(item => item.url).join(','),
                            faultPhenomenon: row.faultPhenomenon,
                            videoUrl: row.faultVideos.map(item => item.url).join(','),
                            engineerId: row.engineerId
                        }))
                    };
                    console.log('payload::: ', payload);

                    const res = await addAfterSaleOrder(payload);
                    if (res.code !== '200') {
                        throw new Error(res.message);
                    }

                    this.$message.success("提交成功");
                    this.closeDialog();
                } catch (error) {
                    this.$message.error(error.message || "提交失败");
                }
            });
        },
        // 单行提交(适用于多产品场景下的逐行处理)
        submitRow(index) {
            this.$refs.infoForm.validate((valid) => {
                if (!valid) {
                    this.$message.error("请完善基本信息");
                    return;
                }
                this.doSubmitRow(index).catch(err => {
                    this.$message.error(err.message || "提交失败");
                });
            });
        },
        async doSubmitRow(index) {
            const row = this.productFaults[index];
            if (!row) return;
            if (!row.goodsId) {
                throw new Error("请先选择产品");
            }
            if (row.submitted || row.submitting) return;

            row.submitting = true;
            try {
                const payload = {
                    declarationId: this.info.declarationId,
                    contactsName: this.info.contactsName,
                    contactsMobile: this.info.contactsMobile,
                    customAddress: this.info.customAddress,
                    goods: [{
                        goodsId: row.goodsId,
                        delivery: row.delivery,
                        warehouseId: row.delivery === '0' ? row.warehouseId : '',
                        faultPhotos: row.faultPhotos.map(item => item.url).join(','),
                        faultPhenomenon: row.faultPhenomenon,
                        videoUrl: row.faultVideos.map(item => item.url).join(','),
                        engineerId: row.engineerId
                    }]
                };
                const res = await addAfterSaleOrder(payload);
                if (res.code !== '200') {
                    throw new Error(res.message);
                }
                // 关键: 提交成功后,立即将该行标记为已提交,
                // 保证界面展示为最新状态,避免用户看到过期数据。
                row.submitted = true;
                this.$message.success("提交成功");
            } finally {
                row.submitting = false;
            }
        },
        handleRemote(query) {
            if (this.remoteTimeout) {
                clearTimeout(this.remoteTimeout);
            }

            this.remoteTimeout = setTimeout(() => {
                // eslint-disable-next-line no-control-regex
                const isChineseChar = /[^\x00-\xff]/.test(query);
                const isValidMobile = /^\d{8,}$/.test(query);

                if (isChineseChar || isValidMobile) {
                    this.users = [];
                    const params = {
                        type: "JOINS_ENGINEER",
                        mobile: query,
                    };

                    findUserList(params).then((res) => {
                        if (res.code === "200") {
                            this.users = JSON.parse(res.data);
                        } else {
                            this.$message.error(res.message);
                        }
                    });
                }
            }, 200);
        },
        closeDialog() {
            // 多产品场景下,如果还有未提交的产品,需要二次确认,
            // 提醒用户还有产品未完成报售后。
            if (this.productFaults.length > 1 && this.submittedCount < this.productFaults.length) {
                const pending = this.productFaults.length - this.submittedCount;
                this.$confirm(
                    `当前还有 ${pending} 个产品未提交,确认关闭弹窗?`,
                    "提示",
                    {
                        confirmButtonText: "确认关闭",
                        cancelButtonText: "继续操作",
                        type: "warning",
                    }
                ).then(() => {
                    this.resetForm();
                    this.$emit("update:visibleAfterSales", false);
                }).catch(() => { });
                return;
            }
            this.resetForm();
            this.$emit("update:visibleAfterSales", false);
        },
        // 重置表单内容
        resetForm() {
            this.productFaults = [this.getInitialProductFault()];
            this.info = this.getInitialInfo();
        },
        handleUploaded(urls, row) {
            row.faultPhotos = urls;
        },
        handleUploadVideo(urls, row) {
            row.faultVideos = urls;
        },
        loadData() {
            getMerchantOrder(this.afterSalesId).then(res => {
                if (res.code === "200") {
                    const data = JSON.parse(res.data).rows[0];
                    // console.log('data::: ', data);
                    this.info = {
                        contactsMobile: data.customMobile,
                        contactsName: data.customName,
                        declarationId: data.id,
                        ...data,
                    };
                    // this.findPureWaterGoodsByRootDepartId(data.list);
                    console.log('index.vue ~ line: 596 ~ data ->', data);
                    if (data.list && data.list.length > 0) {
                        this.findPureWaterGoodsByRootDepartId(data.list);
                    } else {
                        getGoodList(data.id).then(res => {
                            if (res.code === "200") {
                                const data = JSON.parse(res.data);
                                console.log('index.vue ~ line: 622 ~ data ->', data);
                                this.findPureWaterGoodsByRootDepartId(data);
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.message,
                                    type: "error"
                                });
                            }
                        })
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        findPureWaterGoodsByRootDepartId(selectedGoods) {
            findPureWaterGoodsByRootDepartId('PURE_WATER').then(res => {
                if (res.code === "200") {
                    this.goodsList = JSON.parse(res.data).filter(item => selectedGoods.map(item => item.goodsId).includes(item.id));
                } else {
                    this.$message({
                        showClose: true,
                        message: res.message,
                        type: "error"
                    });
                }
            });
        },
        addRow() {
            if (this.canAddRow) {
                this.productFaults.push(this.getInitialProductFault());
            }
        },
        removeRow(index) {
            this.productFaults.splice(index, 1);
        },
        handleGoodsChange(row) {
            const goods = this.goodsList.find(item => item.id === row.goodsId);
            if (goods) {
                row.goodsName = goods.name;
            }
        },
    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
}

.filter-bar {
    margin-bottom: 20px;
    display: flex;
    gap: 10px;
}

.filter-item {
    flex: 1;
}

.dialog-footer {
    text-align: right;
}

.footer-tip {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-right: 16px;
    color: #909399;
    font-size: 13px;
}

.footer-tip i {
    color: #409EFF;
}
</style>
